import { Injectable } from '@angular/core';
import { EntityStateStore } from '@shared/store/entity-state-store';
import { UserAccountEntity } from '@/app/platform/platform-data/models/user-account.entity';

@Injectable({
  providedIn: 'root'
})
export class UserAccountEntityStore extends EntityStateStore<UserAccountEntity> {
  constructor() {
    super();
  }
}
